"use client";

import { MotionValue, useTransform } from "motion/react";
import * as motion from "motion/react-client";

export function ProgressCross({
  progress,
  size,
  strokeWidth = 2,
  color = "var(--yz-error)"
}: {
  progress: MotionValue<number>;
  size?: number;
  strokeWidth?: number;
  color?: string | MotionValue<string>;
}) {
  const crossPathAProgress = useTransform(progress, [0, 0.55], [0, 1]);
  const crossPathBProgress = useTransform(progress, [0.5, 1], [0, 1]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      preserveAspectRatio="xMidYMid meet"
      style={{
        width: size ?? "100%",
        height: size ?? "100%",
        overflow: "visible"
      }}>
      <motion.path
        fill="none"
        strokeWidth={strokeWidth}
        stroke={color}
        d="M17,17 L33,33"
        strokeDasharray="0 1"
        style={{ pathLength: crossPathAProgress }}
      />
      <motion.path
        fill="none"
        strokeWidth={strokeWidth}
        stroke={color}
        d="M33,17 L17,33"
        strokeDasharray="0 1"
        style={{ pathLength: crossPathBProgress }}
      />
    </svg>
  );
}
